export enum BeneficjentRole {
  ADMINISTRATOR = 'ADMINISTRATOR',
}
